<template>
  <li
    class="dropdown-submenu"
    :class="{ 'is-open': isOpen }"
  >
    <button
      type="button"
      class="dropdown-item dropdown-submenu-toggle"
      aria-haspopup="true"
      :aria-expanded="String(isOpen)"
      @click.stop.prevent="toggle"
    >
      <span>{{ label }}</span>
      <font-awesome-icon :icon="['fas', 'chevron-right']" class="submenu-chevron" />
    </button>
    <ul class="dropdown-menu">
      <slot />
    </ul>
  </li>
</template>

<script>
export default {
  name: 'NavSubmenu',
  props: {
    label: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggle() {
      if (window.matchMedia('(max-width: 991px)').matches) {
        this.isOpen = !this.isOpen;
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/base/_variables.scss";
@import "@/assets/styles/base/_mixins.scss";

.dropdown-submenu {
  position: relative;
  list-style: none;

  > .dropdown-submenu-toggle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border: none;
    background: transparent;
    text-align: left;
    cursor: pointer;

    .submenu-chevron {
      margin-left: 0.75rem;
      font-size: 0.75em;
    }
  }

  > .dropdown-menu {
    margin: 0;
    border-radius: 0.25rem;
    z-index: 1001;
  }

  @include media(desktop-only) {
    > .dropdown-menu {
      display: none;
      position: absolute;
      top: 0;
      left: 100%;
      right: auto;
      margin-left: -0.125rem;
    }

    &:hover > .dropdown-menu,
    &:focus-within > .dropdown-menu {
      display: block;
    }

    > .dropdown-submenu-toggle .submenu-chevron {
      transform: none;
    }
  }

  @include media(tablet) {
    > .dropdown-menu {
      display: none;
      position: static;
      float: none;
      width: 100%;
      margin-top: 0;
      border: none;
      box-shadow: none;
      padding-left: 0.75rem;
    }

    &.is-open > .dropdown-menu {
      display: block;
    }

    &.is-open > .dropdown-submenu-toggle .submenu-chevron {
      transform: rotate(90deg);
    }
  }
}
</style>
